import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardSenderImageOption')(function discardSenderImageOption(state) {
    var optionState = state.optionState;
    optionState.showSenderImageInListView = null;
}));
//# sourceMappingURL=discardSenderImageOption.js.map